import { formatMillions } from '../ceoFormat';
import {
  KpiCard,
  KpiCardLabel,
  KpiCardValue,
  KpiStrip,
  KpiSubtext,
  KpiSuccessText,
  KpiWarningValue,
} from './styles';

interface DebtsKpiStripProps {
  totalCreditPrincipal: number;
  availableCreditLimit: number;
  totalLeasingPrincipal: number;
  leasedUnitsTotal: number;
  totalGuaranteesAmount: number;
  paymentsNext30d: number;
  paymentsNext7d: number;
}

export function DebtsKpiStrip({
  totalCreditPrincipal,
  availableCreditLimit,
  totalLeasingPrincipal,
  leasedUnitsTotal,
  totalGuaranteesAmount,
  paymentsNext30d,
  paymentsNext7d,
}: DebtsKpiStripProps) {
  return (
    <KpiStrip>
      <KpiCard>
        <KpiCardLabel>КРЕДИТНЫЙ ПОРТФЕЛЬ (ВКЛ / НКЛ)</KpiCardLabel>
        <KpiCardValue>{formatMillions(totalCreditPrincipal)}</KpiCardValue>
        <KpiSuccessText>
          Доступно к выборке: {formatMillions(availableCreditLimit)}
        </KpiSuccessText>
      </KpiCard>
      <KpiCard>
        <KpiCardLabel>ПОРТФЕЛЬ ЛИЗИНГА СПЕЦТЕХНИКИ</KpiCardLabel>
        <KpiCardValue>{formatMillions(totalLeasingPrincipal)}</KpiCardValue>
        <KpiSubtext>
          В лизинге: {leasedUnitsTotal} ед. техники и лабораторий
        </KpiSubtext>
      </KpiCard>
      <KpiCard>
        <KpiCardLabel>БАНКОВСКИЕ ГАРАНТИИ (БГ)</KpiCardLabel>
        <KpiCardValue>{formatMillions(totalGuaranteesAmount)}</KpiCardValue>
        <KpiSubtext>
          Обеспечение авансов и исполнения контрактов
        </KpiSubtext>
      </KpiCard>
      <KpiCard>
        <KpiCardLabel>К ВЫПЛАТЕ В БЛИЖАЙШИЕ 30 ДНЕЙ</KpiCardLabel>
        <KpiWarningValue>{formatMillions(paymentsNext30d)}</KpiWarningValue>
        <KpiSubtext>
          В т.ч. ближайшие 7 дней: {formatMillions(paymentsNext7d)}
        </KpiSubtext>
      </KpiCard>
    </KpiStrip>
  );
}
